<template>
  <div class="contact inverse">
    <div class="container">
      <div class="section">
        <div class="title-col">
          <h3>Contact</h3>
          <hr>
        </div>
        <div class="content-col">
          <p>
            <span>Find me on the interwebs</span>
            <em>zensign@gmail.com</em>
          </p>
          <p>
            <a href="https://www.linkedin.com/in/zensign" target="_blank">
              <img src="../assets/images/linkedin.svg" width="80" height="80" />
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Experience'
}
</script>
